'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trigger = exports.TooltipWrapper = exports.Tooltip = exports.ContentWrapper = exports.Arrow = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n  box-shadow: -2px 2px 4px 0 rgba(0, 0, 0, 0.1);\n  height: 10px;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translate(-50%, -50%) rotateZ(45deg);\n  width: 10px;\n\n  ', '\n'], ['\n  background-color: ', ';\n  box-shadow: -2px 2px 4px 0 rgba(0, 0, 0, 0.1);\n  height: 10px;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translate(-50%, -50%) rotateZ(45deg);\n  width: 10px;\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 1em;\n  position: relative;\n'], ['\n  padding: 1em;\n  position: relative;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border-radius: 3px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n  font-size: ', 'px;\n  left: 100%;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  transform: translate(10px, -50%);\n  transition: opacity .3s, width 0 .3s;\n  width: 0;\n\n  ', '\n\n  ', '\n'], ['\n  background-color: ', ';\n  border-radius: 3px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n  font-size: ', 'px;\n  left: 100%;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  transform: translate(10px, -50%);\n  transition: opacity .3s, width 0 .3s;\n  width: 0;\n\n  ', '\n\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: inline-block;\n  position: relative;\n'], ['\n  display: inline-block;\n  position: relative;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  background: none;\n  border: 0;\n  cursor: pointer;\n  font: inherit;\n  outline: 0;\n  padding: 0;\n'], ['\n  background: none;\n  border: 0;\n  cursor: pointer;\n  font: inherit;\n  outline: 0;\n  padding: 0;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Arrow = exports.Arrow = _styledComponents2.default.div(_templateObject, function (props) {
  return props.theme.color.white;
}, function (props) {
  if (props.position === 'left') {
    return '\n        left: auto;\n        right: 0;\n        transform: translate(50%, -50%) rotateZ(45deg);\n        box-shadow: 2px -2px 4px 0 rgba(0, 0, 0, 0.1);\n      ';
  }

  if (props.position === 'top') {
    return '\n        top: auto;\n        bottom: 0;\n        left: 50%;\n        transform: translate(-50%, 50%) rotateZ(45deg);\n        box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.1);\n      ';
  }

  if (props.position === 'bottom') {
    return '\n        top: 0;\n        left: 50%;\n        box-shadow: -2px -2px 4px 0 rgba(0, 0, 0, 0.1);\n      ';
  }

  return '';
});

Arrow.displayName = 'Arrow';
var ContentWrapper = exports.ContentWrapper = _styledComponents2.default.div(_templateObject2);

ContentWrapper.displayName = 'ContentWrapper';
var Tooltip = exports.Tooltip = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.theme.color.white;
}, function (props) {
  return props.theme.size[3];
}, function (props) {
  return props.visible && '\n    opacity: 1;\n    width: ' + props.width + ';\n    transition: opacity .3s;\n    pointer-events: all;\n  ';
}, function (props) {
  if (props.position === 'left') {
    return '\n        left: auto;\n        right: 100%;\n        transform: translate(-10px, -50%);\n      ';
  }

  if (props.position === 'top') {
    return '\n        top: auto;\n        bottom: 100%;\n        left: 50%;\n        transform: translate(-50%, -10px);\n      ';
  }

  if (props.position === 'bottom') {
    return '\n        top: 100%;\n        left: 50%;\n        transform: translate(-50%, 10px);\n      ';
  }

  return '';
});

Tooltip.displayName = 'Tooltip';
var TooltipWrapper = exports.TooltipWrapper = _styledComponents2.default.div(_templateObject4);

TooltipWrapper.displayName = 'TooltipWrapper';
var Trigger = exports.Trigger = _styledComponents2.default.button(_templateObject5);
Trigger.displayName = 'Trigger';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-tooltip/styles.js
// module id = 3052
// module chunks = 4